"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _ArrowDropDown = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    boxSizing: "border-box",
    position: "relative",
    display: "block",
    width: "100%",
    fontFamily: "Akkurat, sans-serif",
    fontSize: "14px",
    lineHeight: "24px",
    "&[role=group] + *": {
      borderTop: "1px solid",
      borderTopColor: theme.palette.divider,
      marginTop: theme.spacing(1.5),
      paddingTop: theme.spacing(1.5)
    },
    "& + &[role=group]": {
      borderTop: "1px solid",
      borderTopColor: theme.palette.divider,
      marginTop: theme.spacing(1.5),
      paddingTop: theme.spacing(1.5),
      "& + *": {
        borderTop: "1px solid",
        borderTopColor: theme.palette.divider,
        marginTop: theme.spacing(1.5),
        paddingTop: theme.spacing(1.5)
      }
    }
  },
  toggle: {
    position: "absolute",
    left: "-24px",
    padding: 0,
    margin: 0,
    opacity: 0.5
  },
  toggleCollapsed: {
    transition: ".125s ease-in-out",
    transform: "rotate(-90deg)"
  },
  toggleExpanded: {
    transition: ".125s ease-in-out",
    transform: "rotate(0deg)"
  },
  count: {
    position: "absolute",
    right: 0,
    fontFamily: "Akkurat, sans-serif",
    fontSize: "12px",
    fontStyle: "normal",
    lineHeight: "24px",
    opacity: 0.5
  }
}));

const MenuToggle = ({
  expanded = false,
  onClick
}) => {
  const classes = useStyles();
  const toggleIcon = expanded && classes.toggleExpanded || classes.toggleCollapsed;
  return _react.default.createElement(_IconButton.default, {
    className: classes.toggle,
    onClick: onClick,
    "aria-expanded": expanded,
    size: "small"
  }, _react.default.createElement(_ArrowDropDown.default, {
    className: toggleIcon
  }));
};

const MenuItem = ({
  className,
  role = "treeitem",
  count,
  expanded = false,
  onToggle,
  children
}) => {
  const classes = useStyles();
  return _react.default.createElement("li", {
    className: className || classes.root,
    role: role,
    "aria-expanded": expanded
  }, onToggle && _react.default.createElement(MenuToggle, {
    expanded: expanded,
    onClick: onToggle
  }), children);
};

var _default = MenuItem;
exports.default = _default;
module.exports = exports.default;